module.exports = __webpack_public_path__ + "static/media/dotted-line.62ab5a09.svg";